import { useState, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTrialStatus } from './useTrialStatus';

interface UseCreateWithTrialCheckReturn {
  handleCreateAction: (createFn: () => void) => void;
  isTrialStatusModalOpen: boolean;
  closeTrialStatusModal: () => void;
  isAdmin: boolean;
}

export function useCreateWithTrialCheck(): UseCreateWithTrialCheckReturn {
  const { user } = useAuth();
  const { isTrialExpired } = useTrialStatus();
  const [isTrialStatusModalOpen, setIsTrialStatusModalOpen] = useState(false);
  const isAdmin = user?.role === 'ADMIN';

  const handleCreateAction = useCallback((createFn: () => void) => {
    if (isTrialExpired) {
      // Show trial expired modal instead of navigating
      setIsTrialStatusModalOpen(true);
    } else {
      // Proceed with the create action
      createFn();
    }
  }, [isTrialExpired]);

  const closeTrialStatusModal = useCallback(() => {
    setIsTrialStatusModalOpen(false);
  }, []);

  return {
    handleCreateAction,
    isTrialStatusModalOpen,
    closeTrialStatusModal,
    isAdmin
  };
}

export default useCreateWithTrialCheck;